var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88015 25.3236L5.33671 24.9701C6.66986 26.3938 8.29261 27.5592 10.1327 28.3617L11.5186 22.9523C9.29956 21.7068 7.69436 19.5755 7.10745 17.106L1.5083 16.847C1.74304 18.6975 2.33123 20.4614 3.21076 22.0501L2.74978 22.404C3.34308 23.4622 4.0597 24.4418 4.88015 25.3236Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0217 4.6327C27.8464 5.51074 28.5676 6.48714 29.1658 7.54242L28.7015 7.88399C29.6738 9.62003 30.2973 11.5658 30.4919 13.6082L24.9396 13.3491C24.4513 10.693 22.7932 8.37722 20.4467 7.05831L21.8603 1.65667C23.6569 2.44892 25.2465 3.58408 26.5598 4.9724L27.0217 4.6327Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97429 9.16657C8.56729 9.65185 8.21069 10.1844 7.90963 10.7543L2.53209 9.34799C4.56833 4.49131 9.10932 1.09648 14.3315 0.509521L14.0722 6.08702C13.1624 6.27967 12.2962 6.61217 11.5001 7.06338C11.3526 7.14532 11.2081 7.23132 11.066 7.32489L10.8178 7.48871L10.5617 7.66932C9.9772 8.10236 9.44343 8.60434 8.97429 9.16657Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2341 21.0715C27.1146 25.7067 22.6835 28.9238 17.6103 29.4903L17.8971 23.9097C20.3711 23.3757 22.5231 21.8241 23.8137 19.6515L29.2341 21.0715Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.5543caa9559b7ee6e9b222cd3aedcc7c.svg";
export { ForwardRef as ReactComponent };